import { PieSkeletonQuarterIcon, PieSkeletonThreeQuarterIcon } from '../../../assets/icons';
import { PIE_CHART_SIPLE_CARD_TEST_IDS } from '../../../constants/data-testids';
import { Card, CardContent } from '../../atoms/Card/Card';
import { Skeleton } from '../../atoms/Skeleton/Skeleton';

export const PieChartSimpleSkeleton = () => {
  return (
    <Card
      data-testid={PIE_CHART_SIPLE_CARD_TEST_IDS.SKELETON}
      className="px-[65px] py-[50px] border-custom-warm-grey-150 rounded-[12px]"
    >
      <CardContent className="flex flex-col items-center justify-center">
        <div className="relative w-[220px] h-[220px] mb-6">
          <PieSkeletonQuarterIcon className="absolute top-0 left-0 animate-pulse" />
          <PieSkeletonThreeQuarterIcon className="absolute top-0 right-0 animate-pulse" />

          <div className="absolute flex flex-col gap-3 items-center justify-center top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <Skeleton className="h-[14px] w-[60px]" />
            <Skeleton className="h-[14px] w-[80px]" />
          </div>
        </div>
        <div>
          <Skeleton className="h-[14px] w-[160px]" />
        </div>
      </CardContent>
    </Card>
  );
};
